import React, { useState } from 'react'
import Lottie from '../lotties/lottie';

function Welcome({ user, socket, localVideoIsChecked }) {
    const [request, setRequest] = useState( false )

    const notNewUser = () => {
        try {
            if ( !request ) {
                setRequest( true )
                socket.socket.emit( 'notNewUser' )
            }
        } catch( e ) {
            console.log( e )
        }
    };

    const isNewUser = user && user.playerActivity && user.playerActivity.isNewUser;

    return isNewUser && localVideoIsChecked ? (
        <div style={{ display: 'block' }}>
            <div className='onboarding1 rotating-scaling'>
                <button className="purple_button cardButtonFreeChipsBannerDailyPosition" onClick={ notNewUser }>Take chips</button>
            </div>
            <Lottie
                animationName = 'confetti'
                loop = { false }
                className = 'confettiBackground'
            />
            <div className='popupBackdrop'></div>
        </div>
    ) : null;
}

export default Welcome;